import React, { useCallback } from 'react';
import FormInput from 'components/Input/FormInput';

interface IMenuVersionField {
	changeMenuVersion: (value: string) => void;
}

const MenuVersionField: React.FC<IMenuVersionField> = ({ changeMenuVersion }) => {
	// const handleChange = useCallback(
	// 	(e: React.ChangeEvent<HTMLInputElement>) => {
	// 		e.target.maxLength = 10;
	// 		const onlyDigits = e.target.value.replace(/\D/g, '');
	// 		const validValue = onlyDigits.replace(/^(\d{8})(\d)/, '$1-$2');
	// 		changeMenuVersion(validValue);
	// 		return validValue;
	// 	},
	// 	[changeMenuVersion],
	// );

	return (
		<FormInput
			testId="MenuVersionField"
			name="menuVersion"
			label="menuVersionLabel"
			placeholder="menuVersionPlaceholder"
			// getValueFromEvent={handleChange}
			onChange={changeMenuVersion}
		/>
	);
};

export default React.memo(MenuVersionField);
